import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../utils/components/Button/Button'
import useModal from '../../../../utils/hooks/useModal'
import { Table } from '../../../components/Table/Table'

const LIstJobsView = ({ jobs ,deleteJob}) => {
    const history = useHistory()
    const [refDelete, isShowDelete, setIsShowDelete] = useModal(false)
    const [job, setJob] = useState(null)
    return (
        <div>
            <div className='column mb-5'>
                <Button onClick={() => history.push("/Admin/CreateAdvertising")} text='Crear' />
            </div>
            <Table>
                <thead>
                    <tr>
                        <th>
                            Nombre
                        </th>

                        <th>

                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        jobs.map(job => (
                            <tr key={job._id}>
                                <td>
                                    {job.advertisingType}
                                </td>
                                <td>
                                    <div className='column'>
                                        <Button onClick={() => history.push("/Admin/Advertising/" + job._id)} text='Editar' />
                                        <Button onClick={() => {
                                            setJob(job)
                                            setIsShowDelete(true)
                                        }} text='Borrar' />
                                    </div>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
            <Modal job={job} deleteJob={deleteJob} isShow={isShowDelete} close={() => {

                setIsShowDelete(false)
            }} />
        </div>
    )
}
const Modal = ({ isShow, close, job,deleteJob }) => {
    const divStyle = {
        display: isShow ? 'block' : 'none'
    }
    if (!job) {
        return <></>
    }
    return (
        <div
            className={"modal"}
            style={divStyle}>
            <div className="modal-content modal-content-new-post">
                <Button onClick={() => {
                    deleteJob(job._id,()=>{ close()})
                   
                }} text='Borrar' />
                <Button onClick={() => {
                    close()
                }} text='Cancelar' />

            </div>

        </div >
    )
}
export default LIstJobsView